import { salesApiInstance } from './client.js';

export const rawCustomersApi = {
  getAll: (params = {}) => salesApiInstance.get('/customers', { params }).then(r => r.data),
  getById: (id) => salesApiInstance.get(`/customers/${id}`).then(r => r.data),
  create: (data) => salesApiInstance.post('/customers', data).then(r => r.data),
  update: (id, data) => salesApiInstance.put(`/customers/${id}`, data).then(r => r.data),
  delete: (id) => salesApiInstance.delete(`/customers/${id}`).then(r => r.data),
};

export const retailCustomersApi = {
  getAll:        (params = {})       => salesApiInstance.get('/retail-customers', { params }).then(r => r.data),
  getById:       (id)                => salesApiInstance.get(`/retail-customers/${id}`).then(r => r.data),
  create:        (data)              => salesApiInstance.post('/retail-customers', data).then(r => r.data),
  update:        (id, data)          => salesApiInstance.put(`/retail-customers/${id}`, data).then(r => r.data),
  delete:        (id)                => salesApiInstance.delete(`/retail-customers/${id}`).then(r => r.data),
  bulkAssign:    (data)              => salesApiInstance.put('/retail-customers/bulk-assign', data).then(r => r.data),
  getRemarks:    (id)                => salesApiInstance.get(`/retail-customers/${id}/remarks`).then(r => r.data),
  addRemark:     (id, data)          => salesApiInstance.post(`/retail-customers/${id}/remarks`, data).then(r => r.data),
  deleteRemark:  (id, remarkId)      => salesApiInstance.delete(`/retail-customers/${id}/remarks/${remarkId}`).then(r => r.data),
  getVisits:     (id, params = {})   => salesApiInstance.get(`/retail-customers/${id}/visits`, { params }).then(r => r.data),
};

export const customerImportApi = {
  downloadSample: () => salesApiInstance.get('/customers/import/sample', { responseType: 'blob' }),
  importCsv: (csvText) => salesApiInstance.post('/customers/import', csvText, {
    headers: { 'Content-Type': 'text/plain' },
  }).then(r => r.data),
};

export const corporateCustomersApi = {
  getAll:        (params = {})       => salesApiInstance.get('/corporate-customers', { params }).then(r => r.data),
  getById:       (id)                => salesApiInstance.get(`/corporate-customers/${id}`).then(r => r.data),
  create:        (data)              => salesApiInstance.post('/corporate-customers', data).then(r => r.data),
  update:        (id, data)          => salesApiInstance.put(`/corporate-customers/${id}`, data).then(r => r.data),
  delete:        (id)                => salesApiInstance.delete(`/corporate-customers/${id}`).then(r => r.data),
  bulkAssign:    (data)              => salesApiInstance.put('/corporate-customers/bulk-assign', data).then(r => r.data),
  getRemarks:    (id)                => salesApiInstance.get(`/corporate-customers/${id}/remarks`).then(r => r.data),
  addRemark:     (id, data)          => salesApiInstance.post(`/corporate-customers/${id}/remarks`, data).then(r => r.data),
  deleteRemark:  (id, remarkId)      => salesApiInstance.delete(`/corporate-customers/${id}/remarks/${remarkId}`).then(r => r.data),
  getVisits:     (id, params = {})   => salesApiInstance.get(`/corporate-customers/${id}/visits`, { params }).then(r => r.data),
};
